export const title = 'Please complete the form';
export const title_1 = 'Project Information';
export const title_2 = 'Your Information';
export const title_3 = 'Company Information';

export const link = 'Request Quote';
